// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"847":"b5fab2f2","1283":"60f744b4","1988":"b5fab2f2"}[chunkId] + ".chunk.css";
};